
import { useTranslation } from 'react-i18next';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function PrivacyPage() {
  const { t } = useTranslation('privacy');

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <Navbar />
      
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('title')}</h1>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-12">{t('lastUpdated')}</p>

          {/* Section 1 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section1.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section1.content')}</p>
          </section>

          {/* Section 2 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section2.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('section2.intro')}</p>
            <ul className="space-y-3">
              {(t('section2.items', { returnObjects: true }) as string[]).map((item, index) => (
                <li key={index} className="text-gray-700 dark:text-gray-300 leading-relaxed" dangerouslySetInnerHTML={{ __html: item }} />
              ))}
            </ul>
          </section>

          {/* Section 3 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section3.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('section3.intro')}</p>
            <ul className="space-y-3">
              {(t('section3.items', { returnObjects: true }) as string[]).map((item, index) => (
                <li key={index} className="text-gray-700 dark:text-gray-300 leading-relaxed">{item}</li>
              ))}
            </ul>
          </section>

          {/* Section 4 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section4.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('section4.intro')}</p>
            <ul className="space-y-3">
              {(t('section4.items', { returnObjects: true }) as string[]).map((item, index) => (
                <li key={index} className="text-gray-700 dark:text-gray-300 leading-relaxed" dangerouslySetInnerHTML={{ __html: item }} />
              ))}
            </ul>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mt-4 font-medium">{t('section4.note')}</p>
          </section>

          {/* Section 5 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section5.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('section5.intro')}</p>
            <ul className="space-y-3">
              {(t('section5.items', { returnObjects: true }) as string[]).map((item, index) => (
                <li key={index} className="text-gray-700 dark:text-gray-300 leading-relaxed">{item}</li>
              ))}
            </ul>
          </section>

          {/* Section 6 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section6.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section6.content')}</p>
          </section>

          {/* Section 7 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section7.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('section7.intro')}</p>
            <ul className="space-y-3">
              {(t('section7.items', { returnObjects: true }) as string[]).map((item, index) => (
                <li key={index} className="text-gray-700 dark:text-gray-300 leading-relaxed" dangerouslySetInnerHTML={{ __html: item }} />
              ))}
            </ul>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mt-4 font-medium">{t('section7.note')}</p>
          </section>

          {/* Section 8 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section8.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section8.content')}</p>
          </section>

          {/* Section 9 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section9.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section9.content')}</p>
          </section>

          {/* Section 10 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section10.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section10.content')}</p>
          </section>

          {/* Section 11 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section11.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section11.content')}</p>
          </section>

          {/* Section 12 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section12.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section12.content')}</p>
          </section>

          {/* Section 13 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section13.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('section13.intro')}</p>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-2" dangerouslySetInnerHTML={{ __html: t('section13.email') }} />
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-2" dangerouslySetInnerHTML={{ __html: t('section13.phone') }} />
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed" dangerouslySetInnerHTML={{ __html: t('section13.address') }} />
          </section>

          {/* Regional Privacy Information */}
          <section className="mb-12 bg-gray-50 dark:bg-gray-800 p-8 rounded-lg">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-6">{t('regional.title')}</h2>
            
            {/* CCPA */}
            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-3">{t('regional.ccpa.title')}</h3>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">{t('regional.ccpa.intro')}</p>
              <ul className="space-y-2">
                {(t('regional.ccpa.items', { returnObjects: true }) as string[]).map((item, index) => (
                  <li key={index} className="text-gray-700 dark:text-gray-300 leading-relaxed">{item}</li>
                ))}
              </ul>
            </div>

            {/* GDPR */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-3">{t('regional.gdpr.title')}</h3>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('regional.gdpr.content')}</p>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
